const ThemeConstants = {
  // Color Variables
  PRIMARY_MAIN_COLOR: "#333333",
  SECONDARY_MAIN_COLOR: "#444444",
  BUTTON_MAIN_COLOR: "#031795",
  WHITE_COLOR: "#ffffff", //Never change this value as it is used for Fixed elements(like text on images in all themes)
  BLACK_COLOR: "#14142B", //Never change this value as it is used for Fixed elements
  BLACK_COLOR_VARIANT1: "#2d2d39",
  BLACK_COLOR_VARIANT2: "#1D1D25",
  OFF_WHITE_COLOR: "#F5F6F8",
  LIGHT_BLUE_COLOR: "#dff3ff",
  LIGHT_GREY_COLOR: "#707070",
  LIGHT_GREY_COLOR_VARIANT1: "#89909A",
  LIGHT_GREY_COLOR_VARIANT5: "#CED3D9",
  LIGHT_GREY_COLOR_VARIANT7: "#EFF0F7",
  ZAGG_RED: "#AA1A2D",
  // New theme Color Variables
  BODY_COLOR: "#4E4B66",
  BLACK_COLOR_V1: "#14142B",
  BLACK_COLOR_V2: "#2B2742",
  GRAY_COLOR_v1: "#4E4B66",
  GRAY_COLOR_v2: "#A0A3BD",
  LABEL_COLOR: "#6E7191",
  // Font Weight
  FONTWEIGHT_LIGHT: 300,
  FONTWEIGHT_REGULAR: 400,
  FONTWEIGHT_MEDIUM: 400,
  FONTWEIGHT_SEMIBOLD: 400,
  FONTWEIGHT_BOLD: 700,
  // Breakpoints
  XS: 320,
  SM: 600,
  MD: 768,
  EM: 1024,
  LG: 1280,
  XL: 1440,
  // Text Transform
  TEXTTRANSFORMUPPERCASE: "uppercase",
  TEXTTRANSFORMCAPITALIZECASE: "capitalize",
  TEXTTRANSFORMLOWERCASE: "lowercase",

  /***== New Design System Implementation ==***/
  /*  Typography */
  TYPOGRAPHY: {
    HEADING: {
      WEB_LARGE: {
        FONT: {
          SIZE_LG: "80px",
          LG_LINE_HEIGHT: "88px",
          SIZE_EM: "60px",
          EM_LINE_HEIGHT: "68px",
          SIZE_SM: "32px",
          SM_LINE_HEIGHT: "38px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H1LARGE: {
        FONT: {
          SIZE_LG: "60px",
          LG_LINE_HEIGHT: "68px",
          SIZE_EM: "60px",
          EM_LINE_HEIGHT: "68px",
          SIZE_SM: "26px",
          SM_LINE_HEIGHT: "32px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H1: {
        FONT: {
          SIZE_LG: "48px",
          LG_LINE_HEIGHT: "56px",
          SIZE_EM: "48px",
          EM_LINE_HEIGHT: "56px",
          SIZE_SM: "32px",
          SM_LINE_HEIGHT: "38px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H2: {
        FONT: {
          SIZE_LG: "32px",
          LG_LINE_HEIGHT: "40px",
          SIZE_EM: "32px",
          EM_LINE_HEIGHT: "40px",
          SIZE_SM: "24px",
          SM_LINE_HEIGHT: "30px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H3: {
        FONT: {
          SIZE_LG: "24px",
          LG_LINE_HEIGHT: "32px",
          SIZE_EM: "24px",
          EM_LINE_HEIGHT: "32px",
          SIZE_SM: "22px",
          SM_LINE_HEIGHT: "28px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H4: {
        FONT: {
          SIZE_LG: "18px",
          LG_LINE_HEIGHT: "26px",
          SIZE_EM: "18px",
          EM_LINE_HEIGHT: "26px",
          SIZE_SM: "18px",
          SM_LINE_HEIGHT: "26px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H5: {
        FONT: {
          SIZE_LG: "16px",
          LG_LINE_HEIGHT: "24px",
          SIZE_EM: "16px",
          EM_LINE_HEIGHT: "24px",
          SIZE_SM: "16px",
          SM_LINE_HEIGHT: "24px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H6: {
        FONT: {
          SIZE_LG: "14px",
          LG_LINE_HEIGHT: "22px",
          SIZE_EM: "14px",
          EM_LINE_HEIGHT: "22px",
          SIZE_SM: "12px",
          SM_LINE_HEIGHT: "18px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H7: {
        FONT: {
          SIZE_LG: "12px",
          LG_LINE_HEIGHT: "22px",
          SIZE_EM: "12px",
          EM_LINE_HEIGHT: "22px",
          SIZE_SM: "12px",
          SM_LINE_HEIGHT: "22px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
    },
    PARAGRAPH: {
      P1: {
        FONT: {
          SIZE_LG: "18px",
          LG_LINE_HEIGHT: "26px",
          SIZE_EM: "18px",
          EM_LINE_HEIGHT: "26px",
          SIZE_SM: "18px",
          SM_LINE_HEIGHT: "26px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      P2: {
        FONT: {
          SIZE_LG: "16px",
          LG_LINE_HEIGHT: "24px",
          SIZE_EM: "16px",
          EM_LINE_HEIGHT: "24px",
          SIZE_SM: "16px",
          SM_LINE_HEIGHT: "24px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      P3: {
        FONT: {
          SIZE_LG: "14px",
          LG_LINE_HEIGHT: "22px",
          SIZE_EM: "14px",
          EM_LINE_HEIGHT: "22px",
          SIZE_SM: "14px",
          SM_LINE_HEIGHT: "22px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      P4: {
        FONT: {
          SIZE_LG: "12px",
          LG_LINE_HEIGHT: "18px",
          SIZE_EM: "12px",
          EM_LINE_HEIGHT: "18px",
          SIZE_SM: "12px",
          SM_LINE_HEIGHT: "18px",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
    },
    LABEL: {
      LABEL1: {
        FONT: {
          SIZE_LG: "14px",
          LG_LINE_HEIGHT: "20px",
          SIZE_EM: "14px",
          EM_LINE_HEIGHT: "20px",
          SIZE_SM: "14px",
          SM_LINE_HEIGHT: "20px",
        },
        PADDING: {
          SMTOP: "10px",
          SMBOTTOM: "10px",
          LGTOP: "12px",
          LGBOTTOM: "12px",
        },
      },
      LABEL2: {
        FONT: {
          SIZE_LG: "12px",
          LG_LINE_HEIGHT: "20px",
          SIZE_EM: "12px",
          EM_LINE_HEIGHT: "20px",
          SIZE_SM: "12px",
          SM_LINE_HEIGHT: "20px",
        },
        PADDING: {
          SMTOP: "10px",
          SMBOTTOM: "10px",
          LGTOP: "12px",
          LGBOTTOM: "12px",
        },
      },
      LABEL3: {
        FONT: {
          SIZE_LG: "16px",
          LG_LINE_HEIGHT: "20px",
          SIZE_EM: "16px",
          EM_LINE_HEIGHT: "20px",
          SIZE_SM: "14px",
          SM_LINE_HEIGHT: "18px",
        },
        PADDING: {
          SMTOP: "10px",
          SMBOTTOM: "10px",
          LGTOP: "12px",
          LGBOTTOM: "12px",
        },
      },
    },
  },
  ELEMENT: {
    TEXTBOX: {
      BORDER_RADIUS: "30px",
      PADDING: {
        sm: "22px 12px 4px 30px",
        md: "22px 12px 4px 30px",
      },
      PADDINGV2: {
        sm: "25px 12px 12px 12px",
        md: "25px 12px 12px 12px",
      },
      PADDINGV3: {
        sm: "20px 12px 15px 12px",
        md: "20px 12px 15px 12px",
      },
      FONT: {
        SIZE_LG: "14px",
        LG_LINE_HEIGHT: "24px",
        SIZE_EM: "14px",
        EM_LINE_HEIGHT: "24px",
        SIZE_SM: "12px",
        SM_LINE_HEIGHT: "20px",
      },
      LABEL_GAP: "0px 0px 0px 20px",
    },
    BUTTON: {
      BORDER_RADIUS: "30px",
      MEDIUM_HEIGHT: "50px",
      SMALL_HEIGHT: "40px",
      LARGE_HEIGHT: "60px",
      XLARGE_HEIGHT: "60px",
      MIN_WIDTH: "150px",
      MIN_WIDTH_SMALL: "90px",
      CTA_XS_HEIGHT: "25px",
      PADDING: {
        sm: "12px 24px",
        md: "14px 32px",
        lg: "16px 48px",
        xl: "20px 32px",
      },
      MARGIN: {
        TOP: "12px",
        RIGHT: "12px",
        BOTTOM: "12px",
        LEFT: "0px",
        SMMARGIN: "10px 10px 10px 0px",
        MDMARGIN: "10px 10px 10px 0px",
      },
      FONT: {
        SM: "14px",
        MD: "14px",
        LG: "16px",
        XL: "16px",
      },
    },
    SELECT: {
      BORDER_RADIUS: "30px",
      HEIGHT: "60px",
      PADDING: {
        sm: "14px 12px 14px 30px",
        md: "14px 12px 14px 30px",
      },
    },
    ACCORDIAN: {
      BORDER_RADIUS: "20px",
      BORDER: "2px",
      PADDING1: "6px 24px 6px 24px",
      PADDING2: "16px 24px 16px 24px",
      MARGINBOTTOM: "32px",
      PADDING: {
        sm: "7px 16px",
        md: "7px 15px 3px 18px",
        lg: "17px 50px 16px 50px",
        xl: "17px 50px 16px 50px",
      },
    },
    CARD: {
      TYPE_1: {
        BORDER_RADIUS: "20px",
        PADDING_CONTENT: "12px 20px 20px 20px",
        PADDING_IMAGE: "12px 20px 20px 20px",
        ELEVATION4: "0px 10px 15px 0px rgba(0, 0, 0, 0.03);",
        GRADIENT: "linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
      },
    },
    TAB: {
      FONT: {
        SIZE_LG: "16px",
        LG_LINE_HEIGHT: "20px",
        SIZE_EM: "16px",
        EM_LINE_HEIGHT: "20px",
        SIZE_SM: "14px",
        SM_LINE_HEIGHT: "18px",
      },
      PADDING: {
        sm: "12px 24px",
        md: "14px 32px",
        lg: "16px 48px",
        xl: "20px 32px",
      },
      PANEL_PADDING: {
        sm: "10px 15px 0px 0px",
        md: "10px 15px 0px 20px",
        lg: "10px 15px 0px 0px",
        xl: "10px 15px 0px 0px",
      },
      TAB_GAP: "10px",
      BORDER_RADIUS: "20px 20px 0px 0px", //it's for indivisual-2 Tabs only
      BORDER_RADIUS1: "20px 0px 0px 0px", //it's for Wrapper of Tabs only
      INDICATOR_HEIGHT: "4px",
    },
    CHIP: {
      FONT: {
        SIZE_LG: "16px",
        LG_LINE_HEIGHT: "20px",
        SIZE_EM: "16px",
        EM_LINE_HEIGHT: "20px",
        SIZE_SM: "14px",
        SM_LINE_HEIGHT: "18px",
      },
    },
  },
  OVERYLAY: {
    EDITOVERLAY: "50, 130, 250, 0.9",
    BGOVERLAY: "255, 255, 255, 0.3",
    CARDOVERLAY: "0, 0,0, 0.6",
    CARD_GRADIENT: "linear-gradient(185deg,rgba(0,0,0,0) 30%,rgba(0,0,0,.9) 70%)",
  },
  RADIUS: {
    VALUE1: "10px",
    VALUE2: "20px",
  },

  /* Prelem Type 1 PRIMARY (default White background)*/
  PRIMARY_PRELEM: {
    BACKGROUND: "#fff",
    TITLE: "#181818",
    TITLE_V2: "#1F1450",
    PARAGRAPH: "#1E1E1E99",
    LABEL: "#522067",
    LINE: "#CCCCCC",
    LINK: "#522067",
    BUTTON: {
      VARIANT1: {
        COLOR: "#FFFFFF",
        COLOR_HOVER: "#522067",
        BACKGROUND_COLOR: "#522067",
        BACKGROUND_COLOR_HOVER: "#FFFFFF",
        BORDER: "solid 2px  #522067",
        BORDER_HOVER: "solid 2px  #522067",
      },
      VARIANT2: {
        COLOR: "#522067",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#522067",
        BORDER: "solid 2px  #522067",
        BORDER_HOVER: "solid 2px  #522067",
      },
      VARIANT3: {
        COLOR: "#4B9EF9",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#4B9EF9",
        BORDER: "solid 2px  #4B9EF9",
        BORDER_HOVER: "solid 2px  #4B9EF9",
      },
      VARIANT4: {
        COLOR: "#8E8E93",
        COLOR_HOVER: "#14142B",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#14142B",
        BORDER: "solid 2px  #14142B",
        BORDER_HOVER: "solid 2px  #14142B",
      },
      VARIANT5: {
        COLOR: "#FFF",
        COLOR_HOVER: "#fff",
        BACKGROUND_COLOR: "#000",
        BACKGROUND_COLOR_HOVER: "#db1d24",
        BORDER: "solid 2px  transparent",
        BORDER_HOVER: "solid 2px  transparent",
      },
    },
    INPUT: {
      PLACEHOLDER: "#FFFFFF",
      TEXT: "#14142B",
      TEXT_ACTIVE: "#14142B",
      LABEL: "#6E7191",
      BORDER: "solid 1px #6E7191",
      BORDER_ACTIVE: "solid 1px #14142B",
      BORDER_ERROR: "solid 1px #F33E41",
      BORDER_SUCCESS: "solid 1px #0FA069",
      BACKGROUND_FOCUSED: "#fff",
      BACKGROUND_ERROR: "#FFEBEE",
      BACKGROUND_ERROR_TEXT: "#F33E41",
      BACKGROUND_SUCCESS: "#DEF5D9",
      BACKGROUND_SUCCESS_TEXT: "#0FA069",
      DISABLED: "#EFF0F6",
    },
    SELECT: {
      PLACEHOLDER: "#FFFFFF", //Selectbox bg
      LABEL: "#6E7191", //animated tex of focus
      TEXT: "#6E7191", //dropdownlist popup default text
      TEXT_HOVER: "#14142B", //dropdownlist popup hover text color
      TEXT_SELECTED: "#14142B", //dropdownlist selected text color
      TEXT_BACKGROUND_HOVER: "#F7F7FC", //dropdownlist popup hover text background
      BORDER: "solid 1px #D9D9D9",
      BORDER_ACTIVE: "solid 1px #D9D9D9", //focused border color
      ICON_MARGIN: "0px 15px 0px 0px",
      POPUPOVER_OPEN: {
        PADDING: {
          sm: "10px",
          md: "10px",
        },
        BORDER_RADIUS: "12px",
      },
    },
    CHECKBOX: {
      BOX_COLOR: "#14142B",
      BOX_COLOR_ACTIVE: "#14142B",
    },
    SWITCH: {
      BOX_COLOR: "#6E7191",
      BOX_COLOR_ACTIVE: "#14142B",
    },
    RADIO: {
      BOX_COLOR: "#14142B",
      BOX_COLOR_ACTIVE: "#522067",
      SIZE: "24px",
    },
    ACCORDIAN: {
      BACKGROUND: "#fff",
      COLOR: "#14142B",
      COLOR_HEADING: "#14142B",
      COLOR_PARAGRAPH: "#14142B",
      BORDER_COLOR: "#D9DBE9",
    },
    CARDS: {
      VARIANT1: {
        BACKGROUND: "#FFFFFF",
        ALTERNET_BACKGROUND: "#F7F7FC",
        TITLE: "#181818",
        PARAGRAPH: "#1E1E1E99",
        LABEL: "#522067",
        LINK: "#522067",
        BORDER_COLOR: "#CCCCCC",
        BORDER_COLOR_HOVER: "#151515",
        BOX_SHADOW: "2px 2px 20px 0 rgba(0, 0, 0, 0.19)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#F5F5FF",
        ALTERNET_BACKGROUND: "#F7F7FC",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINK: "#522067",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        BOX_SHADOW: "2px 2px 20px 0 rgba(0, 0, 0, 0.19)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT3: {
        //used this for home page hero matches card
        BACKGROUND: "#F2F2F7",
        ALTERNET_BACKGROUND: "#E2E2EA",
        TITLE: "#020403",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINK: "#522067",
        BORDER_COLOR: "#522067",
        BORDER_COLOR_HOVER: "linear-gradient(90deg, #e3a9f6 0%, #E2E2EA 40%, #E2E2EA 100%)",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(90deg, #a9aff6 0%, #E2E2EA 40%, #E2E2EA 100%)",
      },
      ECOM_CARD_BACKGROUND: "#fdfdfd",
      ECOM_MASK_BACKGROUND: "#14142B",
    },
    ACCENTS: {
      VARIANT1: {
        BACKGROUND: "#FAFAFA",
        TITLE: "#1E1E1E",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT2: {
        //ScheduleCompleted/upcoming card/Skelton using this variant
        BACKGROUND: "#F3F4F6",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#221557",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT3: {
        //ScheduleCompleted/upcoming card/Skelton using this variant
        BACKGROUND: "rgba(168, 197, 235, 0.1)",
        TITLE: "rgba(0, 0, 0, 0.7)",
        PARAGRAPH: "#4E4B66",
        LABEL: "#181818",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT4: {
        //SeasonStats Card using this variant
        BACKGROUND: "#913ab6",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT5: {
        //using for ETG sponsor background
        BACKGROUND: "#EEF3FB",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT6: {
        BACKGROUND: "#DEF5D9",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#4B9EF9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      //Only will use this for Rolex Series
      VARIANT7: {
        BACKGROUND: "linear-gradient(180deg, #FAFAFA 0%, #F8F8F8 106.2%)",
        TITLE: "#B4881B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#B4881B",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "#B4881B",
      },
    },
    TABLE: {
      VARIANT1: {
        BACKGROUND: "rgba(255, 255, 255, 1)",
        ROW_BACKGROUND: "rgba(168, 197, 235, 0.25)",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid rgba(0, 0, 0, 0.5)",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        HEADER_BACKGROUND: "#1E1450",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
      VARIANT2: {
        BACKGROUND: "#F3F3F3",
        ROW_BACKGROUND: "#A8C5EB4D",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid #A5A1B9",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        HEADER_BACKGROUND: "#1E1450",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
    },
    NOTIFICATION: {
      SUCCESS: {
        BACKGROUND: "#0EA069",
        COLOR: "#fff",
      },
      WARNING: {
        BACKGROUND: "#FFCC40",
        COLOR: "#fff",
      },
      ERROR: {
        BACKGROUND: "#F33E41",
        COLOR: "#fff",
      },
      INFO: {
        BACKGROUND: "#009DDF",
        COLOR: "#fff",
      },
    },
    POPUP: {
      BACKGROUND: "orange",
      COLOR: "orange",
    },
    TAB: {
      VARIANT1: {
        ROW_BACKGROUND: "#FFFFFF",
        TITLE: "#AFAFAF",
        TITLE_ACTIVE: "#522067",
        TITLE_BACKGROUND: "transparent",
        TITLE_ACTIVE_BACKGROUND: "transparent",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "red",
        BACKGROUND_COLOR_ACTIVE: "green",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "#14142B",
        BORDER_WIDTH: "0",
        TAB_BOTTOM_BORDER: "solid 0px #D9DBE9",
        INDICATOR: "#522067",
        BORDER_RADIUS: "20px 0px 0px 0px",
        PADDING: "10px 15px 0px 20px",
        INDICATOR_HEIGHT: "3px",
      },
      //Used in ETG contained
      VARIANT2: {
        ROW_BACKGROUND: "#f7f7f7",
        TITLE: "#522067",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "transparent",
        TITLE_ACTIVE_BACKGROUND: "#522067",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "#522067",
        BORDER_WIDTH: "1",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#522067",
        BORDER_RADIUS: "70px",
        PADDING: "10px 15px",
        INDICATOR_HEIGHT: "0px",
      },
      //Used in ETG transparent contained
      VARIANT3: {
        ROW_BACKGROUND: "#FFFFFF",
        TITLE: "#AFAFAF",
        TITLE_ACTIVE: "#0095b5",
        TITLE_BACKGROUND: "#FFFFFF",
        TITLE_ACTIVE_BACKGROUND: "#FFFFFF",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#0095b5",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "solid 1px #14142B",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#0095b5",
        BORDER_RADIUS: "40px",
        PADDING: "12px 14px",
        INDICATOR_HEIGHT: "0px",
      },
    },
    GRADIENT: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(90deg, #00EA83 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #02E685 0%, #3534C2 50%, #221554 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT2: {
        BACKGROUND: "linear-gradient(90deg, #F5B400 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #F0B107 0%, #3433BD 50%, #231658 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT3: {
        BACKGROUND: "linear-gradient(90deg, #FF3600 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #FF3600 0%, #3433BD 50%, #231658 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT4: {
        BACKGROUND: "linear-gradient(90deg, #FF3600 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #FF3600 0%, #3433BD 50%, #231658 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
    },
    CHIP: {
      VARIANT1: {
        BACKGROUND: "#522067",
        BACKGROUND_COLOR_ACTIVE: "#522067",
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px #522067",
        BORDER_RADIUS: "30px",
        PADDING: "20px",
      },
      VARIANT2: {
        BACKGROUND: "#FFFFFF",
        BACKGROUND_COLOR_ACTIVE: "#522067",
        TITLE: "#522067",
        TITLE_ACTIVE: "#FFFFFF",
        PARAGRAPH: "#522067",
        LABEL: "#522067",
        LINE: "#522067",
        BORDER: "solid 1px #522067",
        BORDER_RADIUS: "40px",
        PADDING: "20px",
      },
    },
    PROGRESSBAR: {
      VARIANT1: {
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#E0E0E0",
        TITLE_ACTIVE_BACKGROUND: "linear-gradient(90deg, #000 0.01%, #522067 50.83%)",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px  #070247",
        BORDER_HOVER: "solid 1px  #070247",
      },
    },
    CAROUSEL: {
      VARIANT1: {
        ARROW_COLOR: "#FFFFFF",
        ARROW_COLOR_HOVER: "#FFFFFF",
        ARROW_BACKGROUND: "rgba(0, 0, 0, 0.60)",
        ARROW_BACKGROUND_HOVER: "#522067",
        ARROW_BORDER: "solid 0px  #522067",
        ARROW_BORDER_HOVER: "solid 0px  #522067",
        ARROW_RADIUS: "50%",
        DOTS_COLOR: "linear-gradient(180deg, #8a7794 0%, #dbd6df 100%)",
        DOTS_COLOR_ACTIVE: "linear-gradient(180deg, #522067 0%, #441558 100%)",
      },
    },
    SKELTON: {
      BACKGROUND: "rgba(0, 0, 0, 0.11)",
      BACKGROUND_ALTERNATE: "#F2F2F7",
    },
    ANIMATION: {
      VARIANT1: {
        TRANSITION: "opacity .2s ease-out, transform .9s cubic-bezier(.19, 1, .22, 1)",
        DEFAULT_TRANSFORM: "scale(1)",
        HOVER_TRANSFORM: "scale(1.12) rotate(.02deg)",
      },
    },
    TOOLTIP: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(180deg, #070247 0%, #A8C5EB 161.73%)",
        TITLE: "#FFFFFF",
        ARROW: "#070247",
      },
    },
    MODAL: {
      VARIANT1: {
        BACKGROUND: "#fff",
        BORDER_RADIUS: "20px",
      },
    },
  },
  /* Prelem Type 2 SECONDARY (default black background)*/
  SECONDARY_PRELEM: {
    BACKGROUND: "#522067",
    TITLE: "#FFFFFF",
    TITLE_V2: "#1F1450",
    PARAGRAPH: "#EFF0F6",
    LABEL: "#e1a4fa",
    LINE: "#6b48cf",
    LINK: "#e1a4fa",
    BUTTON: {
      VARIANT1: {
        COLOR: "#522067",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "#FFFFFF",
        BACKGROUND_COLOR_HOVER: "transparent",
        BORDER: "solid 2px  #FFFFFF",
        BORDER_HOVER: "solid 2px  #FFFFFF",
      },
      VARIANT2: {
        COLOR: "#FFFFFF",
        COLOR_HOVER: "#522067",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#FFFFFF",
        BORDER: "solid 2px  #FFFFFF",
        BORDER_HOVER: "solid 2px  #FFFFFF",
      },
      VARIANT3: {
        COLOR: "#4B9EF9",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#4B9EF9",
        BORDER: "solid 2px  #4B9EF9",
        BORDER_HOVER: "solid 2px  #4B9EF9",
      },
      VARIANT4: {
        COLOR: "#FFFFFF",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "transparent",
        BORDER: "solid 0px  #FFFFFF",
        BORDER_HOVER: "solid 0px  #FFFFFF",
      },
      VARIANT5: {
        COLOR: "#FFF",
        COLOR_HOVER: "#fff",
        BACKGROUND_COLOR: "#000",
        BACKGROUND_COLOR_HOVER: "#db1d24",
        BORDER: "solid 2px  transparent",
        BORDER_HOVER: "solid 2px  transparent",
      },
    },
    INPUT: {
      PLACEHOLDER: "#343051",
      TEXT: "#89909A",
      TEXT_ACTIVE: "#fffff",
      LABEL: "#6E7191",
      BORDER: "solid 2px transparent",
      BORDER_ACTIVE: "solid 2px #343051",
      BORDER_ERROR: "solid 2px #F33E41",
      BORDER_SUCCESS: "solid 2px #0FA069",
      BACKGROUND_FOCUSED: "#343051",
      BACKGROUND_ERROR: "#FFEBEE",
      BACKGROUND_ERROR_TEXT: "#F33E41",
      BACKGROUND_SUCCESS: "#DEF5D9",
      BACKGROUND_SUCCESS_TEXT: "#0FA069",
      DISABLED: "#FFD970",
    },
    SELECT: {
      PLACEHOLDER: "#343051", //Selectbox bg
      LABEL: "#6E7191", //animated tex of focus
      TEXT: "#6E7191", //dropdownlist popup default text
      TEXT_HOVER: "#ffffff", //dropdownlist popup hover text color
      TEXT_SELECTED: "#FFFFFF", //dropdownlist selected text color
      TEXT_BACKGROUND_HOVER: "#4B9EF9", //dropdownlist popup hover text background
      BORDER: "solid 1px #D9D9D9",
      BORDER_ACTIVE: "solid 1px #D9D9D9", //focused border color
      ICON_MARGIN: "0px 15px 0px 0px",
      POPUPOVER_OPEN: {
        PADDING: {
          sm: "14px 22px 14px 22px",
          md: "14px 22px 14px 22px",
        },
        BORDER_RADIUS: "12px",
      },
    },
    CHECKBOX: {
      BOX_COLOR: "#4B9EF9",
      BOX_COLOR_ACTIVE: "#4B9EF9",
    },
    SWITCH: {
      BOX_COLOR: "#4B9EF9",
      BOX_COLOR_ACTIVE: "#4B9EF9",
    },
    RADIO: {
      BOX_COLOR: "#4B9EF9",
      BOX_COLOR_ACTIVE: "#4B9EF9",
      SIZE: "24px",
    },
    ACCORDIAN: {
      BACKGROUND: "#231C39",
      COLOR: "#fff",
      COLOR_HEADING: "#fff",
      COLOR_PARAGRAPH: "#fff",
      BORDER_COLOR: "#3E306A",
    },
    CARDS: {
      VARIANT1: {
        BACKGROUND: "#FFFFFF",
        ALTERNET_BACKGROUND: "#F7F7FC",
        TITLE: "#181818",
        PARAGRAPH: "#1E1E1E99",
        LABEL: "#522067",
        LINK: "#e1a4fa",
        BORDER_COLOR: "#CCCCCC",
        BORDER_COLOR_HOVER: "#151515",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#292647",
        ALTERNET_BACKGROUND: "#343051",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#EFF0F6",
        LABEL: "#EFF0F6",
        LINK: "#e1a4fa",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT3: {
        //used this for home page hero matches card
        BACKGROUND: "#F2F2F7",
        ALTERNET_BACKGROUND: "#E2E2EA",
        TITLE: "#020403",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINK: "#522067",
        BORDER_COLOR: "#522067",
        BORDER_COLOR_HOVER: "linear-gradient(90deg, #e3a9f6 0%, #E2E2EA 40%, #E2E2EA 100%)",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(90deg, #a9aff6 0%, #E2E2EA 40%, #E2E2EA 100%)",
      },
      ECOM_CARD_BACKGROUND: "#fdfdfd",
      ECOM_MASK_BACKGROUND: "#14142B",
    },
    ACCENTS: {
      VARIANT1: {
        BACKGROUND: "#000",
        TITLE: "#FFF",
        PARAGRAPH: "#FFF",
        LABEL: "#4B9EF9",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#343051",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#4B9EF9",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT3: {
        BACKGROUND: "rgba(168, 197, 235, 0.1)",
        TITLE: "#000000",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT4: {
        BACKGROUND: "#8b19bc",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#6E7191",
        LINE: "#bf56ec",
        ICON: "#bf56ec",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT5: {
        BACKGROUND: "#EEF3FB",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT6: {
        BACKGROUND: "#DEF5D9",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
      },
      //Only will use this for Rolex Series
      VARIANT7: {
        BACKGROUND: "linear-gradient(180deg, #FAFAFA 0%, #F8F8F8 106.2%)",
        TITLE: "#B4881B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#BB9C2B",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "#B4881B",
      },
    },
    TABLE: {
      VARIANT1: {
        BACKGROUND: "rgba(255, 255, 255, 1)",
        ROW_BACKGROUND: "rgba(168, 197, 235, 0.25)",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid rgba(0, 0, 0, 0.5)",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        HEADER_BACKGROUND: "#1E1450",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
      VARIANT2: {
        BACKGROUND: "#F3F3F3",
        ROW_BACKGROUND: "#A8C5EB4D",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid #A5A1B9",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        HEADER_BACKGROUND: "#1E1450",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
    },
    NOTIFICATION: {
      SUCCESS: {
        BACKGROUND: "#0EA069",
        COLOR: "#fff",
      },
      WARNING: {
        BACKGROUND: "#FFCC40",
        COLOR: "#fff",
      },
      ERROR: {
        BACKGROUND: "#F33E41",
        COLOR: "#fff",
      },
      INFO: {
        BACKGROUND: "#009DDF",
        COLOR: "#fff",
      },
    },
    POPUP: {
      BACKGROUND: "orange",
      COLOR: "orange",
    },
    TAB: {
      VARIANT1: {
        ROW_BACKGROUND: "#343051",
        TITLE: "#AFAFAF",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "transparent",
        TITLE_ACTIVE_BACKGROUND: "transparent",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "red",
        BACKGROUND_COLOR_ACTIVE: "green",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "#522067",
        BORDER_WIDTH: "0",
        TAB_BOTTOM_BORDER: "solid 0px #D9DBE9",
        INDICATOR: "#FFFFFF",
        BORDER_RADIUS: "20px 0px 0px 0px",
        PADDING: "10px 15px 0px 20px",
        INDICATOR_HEIGHT: "3px",
      },
      //Used in ETG contained
      VARIANT2: {
        ROW_BACKGROUND: "rgba(168, 197, 235, 0.25)",
        TITLE: "#522067",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "transparent",
        TITLE_ACTIVE_BACKGROUND: "#522067",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "#522067",
        BORDER_WIDTH: "1",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#522067",
        BORDER_RADIUS: "40px",
        PADDING: "12px 14px",
        INDICATOR_HEIGHT: "0px",
      },
      //Used in ETG transparent contained
      VARIANT3: {
        ROW_BACKGROUND: "#FFFFFF",
        TITLE: "#AFAFAF",
        TITLE_ACTIVE: "#522067",
        TITLE_BACKGROUND: "#FFFFFF",
        TITLE_ACTIVE_BACKGROUND: "#FFFFFF",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "solid 1px #14142B",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#522067",
        BORDER_RADIUS: "40px",
        PADDING: "12px 14px",
        INDICATOR_HEIGHT: "0px",
      },
    },
    GRADIENT: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(90deg, #00EA83 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #02E685 0%, #3534C2 50%, #221554 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT2: {
        BACKGROUND: "linear-gradient(90deg, #F5B400 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #F0B107 0%, #3433BD 50%, #231658 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT3: {
        BACKGROUND: "linear-gradient(90deg, #FF3600 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #FF3600 0%, #3433BD 50%, #231658 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
    },
    CHIP: {
      VARIANT1: {
        BACKGROUND: "#522067",
        BACKGROUND_COLOR_ACTIVE: "#522067",
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px #FFFFFF",
        BORDER_RADIUS: "30px",
        PADDING: "20px",
      },
      VARIANT2: {
        BACKGROUND: "#FFFFFF",
        BACKGROUND_COLOR_ACTIVE: "#FFFFFF",
        TITLE: "#1a1a1a",
        TITLE_ACTIVE: "#1a1a1a",
        PARAGRAPH: "#1a1a1a",
        LABEL: "#1a1a1a",
        LINE: "#1a1a1a",
        BORDER: "solid 1px #FFFFFF",
        BORDER_RADIUS: "5px",
        PADDING: "20px",
      },
    },
    PROGRESSBAR: {
      VARIANT1: {
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#E0E0E0",
        TITLE_ACTIVE_BACKGROUND: "linear-gradient(90deg, #000 0.01%, #3230BE 50.83%)",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px  #070247",
        BORDER_HOVER: "solid 1px  #070247",
      },
    },
    CAROUSEL: {
      VARIANT1: {
        ARROW_COLOR: "#FFFFFF",
        ARROW_COLOR_HOVER: "#FFFFFF",
        ARROW_BACKGROUND: "rgba(0, 0, 0, 0.60)",
        ARROW_BACKGROUND_HOVER: "#522067",
        ARROW_BORDER: "solid 0px  #FFFFFF",
        ARROW_BORDER_HOVER: "solid 0px  #4B9EF9",
        ARROW_RADIUS: "50%",
        DOTS_COLOR: "#D9DBE9",
        DOTS_COLOR_ACTIVE: "#4B9EF9",
      },
    },
    SKELTON: {
      BACKGROUND: "rgba(255, 255, 255, 0.11)",
      BACKGROUND_ALTERNATE: "#F2F2F7",
    },
    ANIMATION: {
      VARIANT1: {
        TRANSITION: "opacity .2s ease-out, transform .9s cubic-bezier(.19, 1, .22, 1)",
        DEFAULT_TRANSFORM: "scale(1)",
        HOVER_TRANSFORM: "scale(1.12) rotate(.02deg)",
      },
    },
    TOOLTIP: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(180deg, #070247 0%, #A8C5EB 161.73%)",
        TITLE: "#FFFFFF",
        ARROW: "#070247",
      },
    },
    MODAL: {
      VARIANT1: {
        BACKGROUND: "#fff",
        BORDER_RADIUS: "20px",
      },
    },
  },
  /* Prelem type 3 TERTIARY (default gray background)*/
  TERTIARY_PRELEM: {
    BACKGROUND: "#F7f7f7",
    TITLE: "#181818",
    TITLE_V2: "#1F1450",
    PARAGRAPH: "#1E1E1E99",
    LABEL: "#522067",
    LINE: "#CCCCCC",
    LINK: "#522067",
    BUTTON: {
      VARIANT1: {
        COLOR: "#FFFFFF",
        COLOR_HOVER: "#522067",
        BACKGROUND_COLOR: "#522067",
        BACKGROUND_COLOR_HOVER: "#FFFFFF",
        BORDER: "solid 2px  #522067",
        BORDER_HOVER: "solid 2px  #522067",
      },
      VARIANT2: {
        COLOR: "#522067",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#522067",
        BORDER: "solid 2px  #522067",
        BORDER_HOVER: "solid 2px  #522067",
      },
      VARIANT3: {
        COLOR: "#4B9EF9",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#4B9EF9",
        BORDER: "solid 2px  #4B9EF9",
        BORDER_HOVER: "solid 2px  #4B9EF9",
      },
      VARIANT4: {
        COLOR: "#8E8E93",
        COLOR_HOVER: "#14142B",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#14142B",
        BORDER: "solid 2px  #14142B",
        BORDER_HOVER: "solid 2px  #14142B",
      },
      VARIANT5: {
        COLOR: "#FFF",
        COLOR_HOVER: "#fff",
        BACKGROUND_COLOR: "#000",
        BACKGROUND_COLOR_HOVER: "#db1d24",
        BORDER: "solid 2px  transparent",
        BORDER_HOVER: "solid 2px  transparent",
      },
    },
    INPUT: {
      PLACEHOLDER: "#FFFFFF",
      TEXT: "#14142B",
      TEXT_ACTIVE: "#14142B",
      LABEL: "#6E7191",
      BORDER: "solid 1px #6E7191",
      BORDER_ACTIVE: "solid 1px #14142B",
      BORDER_ERROR: "solid 1px #F33E41",
      BORDER_SUCCESS: "solid 1px #0FA069",
      BACKGROUND_FOCUSED: "#fff",
      BACKGROUND_ERROR: "#FFEBEE",
      BACKGROUND_ERROR_TEXT: "#F33E41",
      BACKGROUND_SUCCESS: "#DEF5D9",
      BACKGROUND_SUCCESS_TEXT: "#0FA069",
      DISABLED: "#EFF0F6",
    },
    SELECT: {
      PLACEHOLDER: "#FFFFFF", //Selectbox bg
      LABEL: "#6E7191", //animated tex of focus
      TEXT: "#6E7191", //dropdownlist popup default text
      TEXT_HOVER: "#14142B", //dropdownlist popup hover text color
      TEXT_SELECTED: "#14142B", //dropdownlist selected text color
      TEXT_BACKGROUND_HOVER: "#F7F7FC", //dropdownlist popup hover text background
      BORDER: "solid 1px #D9D9D9",
      BORDER_ACTIVE: "solid 1px #D9D9D9", //focused border color
      ICON_MARGIN: "0px 15px 0px 0px",
      POPUPOVER_OPEN: {
        PADDING: {
          sm: "10px",
          md: "10px",
        },
        BORDER_RADIUS: "12px",
      },
    },
    CHECKBOX: {
      BOX_COLOR: "#14142B",
      BOX_COLOR_ACTIVE: "#14142B",
    },
    SWITCH: {
      BOX_COLOR: "#6E7191",
      BOX_COLOR_ACTIVE: "#14142B",
    },
    RADIO: {
      BOX_COLOR: "#14142B",
      BOX_COLOR_ACTIVE: "#522067",
      SIZE: "24px",
    },
    ACCORDIAN: {
      BACKGROUND: "#fff",
      COLOR: "#14142B",
      COLOR_HEADING: "#14142B",
      COLOR_PARAGRAPH: "#14142B",
      BORDER_COLOR: "#D9DBE9",
    },
    CARDS: {
      VARIANT1: {
        BACKGROUND: "#FFFFFF",
        ALTERNET_BACKGROUND: "#F7F7FC",
        TITLE: "#181818",
        PARAGRAPH: "#1E1E1E99",
        LABEL: "#522067",
        LINK: "#522067",
        BORDER_COLOR: "#CCCCCC",
        BORDER_COLOR_HOVER: "#151515",
        BOX_SHADOW: "2px 2px 20px 0 rgba(0, 0, 0, 0.19)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#F5F5FF",
        ALTERNET_BACKGROUND: "#F7F7FC",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINK: "#522067",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT3: {
        //used this for home page hero matches card
        BACKGROUND: "#F2F2F7",
        ALTERNET_BACKGROUND: "#E2E2EA",
        TITLE: "#020403",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINK: "#522067",
        BORDER_COLOR: "#522067",
        BORDER_COLOR_HOVER: "linear-gradient(90deg, #e3a9f6 0%, #E2E2EA 40%, #E2E2EA 100%)",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(90deg, #a9aff6 0%, #E2E2EA 40%, #E2E2EA 100%)",
      },
      ECOM_CARD_BACKGROUND: "#fdfdfd",
      ECOM_MASK_BACKGROUND: "#14142B",
    },
    ACCENTS: {
      VARIANT1: {
        BACKGROUND: "#FAFAFA",
        TITLE: "#1E1E1E",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT2: {
        //ScheduleCompleted/upcoming card/Skelton using this variant
        BACKGROUND: "#F3F4F6",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#221557",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT3: {
        //ScheduleCompleted/upcoming card/Skelton using this variant
        BACKGROUND: "rgba(168, 197, 235, 0.1)",
        TITLE: "rgba(0, 0, 0, 0.7)",
        PARAGRAPH: "#4E4B66",
        LABEL: "#181818",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT4: {
        //SeasonStats Card using this variant
        BACKGROUND: "#913ab6",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT:
          "linear-gradient(180deg, var(--Accent-ETG-Sky, #A8C5EB) -57.3%, #FFF 100%)",
      },
      VARIANT5: {
        //using for ETG sponsor background
        BACKGROUND: "#EEF3FB",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT6: {
        BACKGROUND: "#DEF5D9",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#4B9EF9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      //Only will use this for Rolex Series
      VARIANT7: {
        BACKGROUND: "linear-gradient(180deg, #FAFAFA 0%, #F8F8F8 106.2%)",
        TITLE: "#B4881B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#BB9C2B",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "#B4881B",
      },
    },
    TABLE: {
      VARIANT1: {
        BACKGROUND: "rgba(255, 255, 255, 1)",
        ROW_BACKGROUND: "rgba(168, 197, 235, 0.25)",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid rgba(0, 0, 0, 0.5)",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        HEADER_BACKGROUND: "#1E1450",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
      VARIANT2: {
        BACKGROUND: "#F3F3F3",
        ROW_BACKGROUND: "#A8C5EB4D",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid #A5A1B9",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        HEADER_BACKGROUND: "#1E1450",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
    },
    NOTIFICATION: {
      SUCCESS: {
        BACKGROUND: "#0EA069",
        COLOR: "#fff",
      },
      WARNING: {
        BACKGROUND: "#FFCC40",
        COLOR: "#fff",
      },
      ERROR: {
        BACKGROUND: "#F33E41",
        COLOR: "#fff",
      },
      INFO: {
        BACKGROUND: "#009DDF",
        COLOR: "#fff",
      },
    },
    POPUP: {
      BACKGROUND: "orange",
      COLOR: "orange",
    },
    TAB: {
      //Used For Common Schedule
      VARIANT1: {
        ROW_BACKGROUND: "#FFFFFF",
        TITLE: "#AFAFAF",
        TITLE_ACTIVE: "#522067",
        TITLE_BACKGROUND: "transparent",
        TITLE_ACTIVE_BACKGROUND: "transparent",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "red",
        BACKGROUND_COLOR_ACTIVE: "green",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "#14142B",
        BORDER_WIDTH: "0",
        TAB_BOTTOM_BORDER: "solid 0px #D9DBE9",
        INDICATOR: "#522067",
        BORDER_RADIUS: "20px 0px 0px 0px",
        PADDING: "10px 15px 0px 20px",
        INDICATOR_HEIGHT: "3px",
      },
      //Used in ETG contained
      VARIANT2: {
        ROW_BACKGROUND: "#f7f7f7",
        TITLE: "#522067",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "transparent",
        TITLE_ACTIVE_BACKGROUND: "#522067",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "#522067",
        BORDER_WIDTH: "1",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#522067",
        BORDER_RADIUS: "70px",
        PADDING: "10px 15px",
        INDICATOR_HEIGHT: "0px",
      },
      //Used in ETG transparent contained
      VARIANT3: {
        ROW_BACKGROUND: "#FFFFFF",
        TITLE: "#AFAFAF",
        TITLE_ACTIVE: "#0095b5",
        TITLE_BACKGROUND: "#FFFFFF",
        TITLE_ACTIVE_BACKGROUND: "#FFFFFF",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#0095b5",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "solid 1px #14142B",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#0095b5",
        BORDER_RADIUS: "40px",
        PADDING: "12px 14px",
        INDICATOR_HEIGHT: "0px",
      },
    },
    GRADIENT: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(90deg, #00EA83 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #02E685 0%, #3534C2 50%, #221554 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT2: {
        BACKGROUND: "linear-gradient(90deg, #F5B400 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #F0B107 0%, #3433BD 50%, #231658 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT3: {
        BACKGROUND: "linear-gradient(90deg, #FF3600 0%, #3630C3 50.48%, #211453 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #FF3600 0%, #3433BD 50%, #231658 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
    },
    CHIP: {
      VARIANT1: {
        BACKGROUND: "#522067",
        BACKGROUND_COLOR_ACTIVE: "#522067",
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px #522067",
        BORDER_RADIUS: "30px",
        PADDING: "20px",
      },
      VARIANT2: {
        BACKGROUND: "#FFFFFF",
        BACKGROUND_COLOR_ACTIVE: "#522067",
        TITLE: "#522067",
        TITLE_ACTIVE: "#FFFFFF",
        PARAGRAPH: "#522067",
        LABEL: "#522067",
        LINE: "#522067",
        BORDER: "solid 1px #522067",
        BORDER_RADIUS: "40px",
        PADDING: "20px",
      },
    },
    PROGRESSBAR: {
      VARIANT1: {
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#E0E0E0",
        TITLE_ACTIVE_BACKGROUND: "linear-gradient(90deg, #000 0.01%, #522067 50.83%)",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px  #070247",
        BORDER_HOVER: "solid 1px  #070247",
      },
    },
    CAROUSEL: {
      VARIANT1: {
        ARROW_COLOR: "#FFFFFF",
        ARROW_COLOR_HOVER: "#FFFFFF",
        ARROW_BACKGROUND: "rgba(0, 0, 0, 0.60)",
        ARROW_BACKGROUND_HOVER: "#522067",
        ARROW_BORDER: "solid 0px  #522067",
        ARROW_BORDER_HOVER: "solid 0px  #522067",
        ARROW_RADIUS: "50%",
        DOTS_COLOR:
          "linear-gradient(165deg, rgba(255, 255, 255, 0.30) -2.34%, rgba(255, 255, 255, 0.00) 165.86%)",
        DOTS_COLOR_ACTIVE:
          "linear-gradient(184deg, rgba(255, 255, 255, 0.70) 3.43%, rgba(255, 255, 255, 0.40) 236.28%)",
      },
    },
    SKELTON: {
      BACKGROUND: "rgba(0, 0, 0, 0.11)",
      BACKGROUND_ALTERNATE: "#F2F2F7",
    },
    ANIMATION: {
      VARIANT1: {
        TRANSITION: "opacity .2s ease-out, transform .9s cubic-bezier(.19, 1, .22, 1)",
        DEFAULT_TRANSFORM: "scale(1)",
        HOVER_TRANSFORM: "scale(1.12) rotate(.02deg)",
      },
    },
    TOOLTIP: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(180deg, #070247 0%, #A8C5EB 161.73%)",
        TITLE: "#FFFFFF",
        ARROW: "#070247",
      },
    },
    MODAL: {
      VARIANT1: {
        BACKGROUND: "#fff",
        BORDER_RADIUS: "20px",
      },
    },
  },
  HEADER: {
    HEADER_HEIGHT: "60px",
    VARIANT1: {
      BACKGROUND: "#FFFFFF", //this variant set is used for template type two
      BACKGROUND_HOVER: "#F5F5FF",
      TITLE: "#14142B",
      TITLE_HOVER: "#14142B",
      PARAGRAPH: "#4E4B66",
      PARAGRAPH_HOVER: "#4E4B66",
      LABEL: "#6E7191",
      LABEL_HOVER: "#6E7191",
      LINE: "#D9DBE9",
      LINE_HOVER: "#D9DBE9",
      BORDER_COLOR: "#D9DBE9",
      BORDER_COLOR_HOVER: "#14142B",
      LINK: "#00ADEE",
      LINK_HOVER: "#00ADEE",
      BUTTON: {
        COLOR: "#1a1a1a",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "#FFFFFF",
        BACKGROUND_COLOR_HOVER: "#14142B",
        BORDER_COLOR: "#14142B",
        BORDER_COLOR_HOVER: "#14142B",
      },
      BADGE: {
        BACKGROUND: "#4B9EF9",
        TITLE: "#FFF",
      },
      SUBMENU: {
        CARD_BACKGROUND: "#FFF",
        BACKGROUND: "#FFF",
        BACKGROUND_HOVER: "#FFF",
        TITLE: "#000",
        TITLE_HOVER: "#ED7426",
        PARAGRAPH: "#3A3A3A",
        PARAGRAPH_HOVER: "#3A3A3A",
        LABEL: "#ED7426",
        LABEL_HOVER: "#ED7426",
        LINE: "#D9DBE9",
        LINE_HOVER: "#D9DBE9",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        LINK: "#00ADEE",
        LINK_HOVER: "#00ADEE",
      },
      TOPMENU: {
        BACKGROUND: "#00ADEE",
        BACKGROUND_HOVER: "#0b9bd0",
        TITLE: "#FFFFFF",
        TITLE_HOVER: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        PARAGRAPH_HOVER: "#FFFFFF",
        LINE: "#D9DBE9",
        LINE_HOVER: "#D9DBE9",
        BUTTON: {
          COLOR: "#fff",
          COLOR_HOVER: "#fff",
          BACKGROUND_COLOR: "transparent",
          BACKGROUND_COLOR_HOVER: "transparent",
          BORDER_COLOR: "#FFFFFF",
          BORDER_COLOR_HOVER: "#e3e52c",
        },
      },
    },
    VARIANT2: {
      BACKGROUND: "#522067", //this variant set is used for template one
      BACKGROUND_HOVER: "#522067",
      TITLE: "#FFFFFF",
      TITLE_HOVER: "#FFFFFF",
      PARAGRAPH: "#FFFFFF",
      PARAGRAPH_HOVER: "#FFFFFF",
      LABEL: "#FFFFFF",
      LABEL_HOVER: "#FFFFFF",
      LINE: "#FFFFFF",
      LINE_HOVER: "#FFFFFF",
      BORDER_COLOR: "#1E1450",
      BORDER_COLOR_HOVER: "#1E1450",
      LINK: "#00ADEE",
      LINK_HOVER: "#00ADEE",
      BUTTON: {
        COLOR: "#1a1a1a",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "#FFFFFF",
        BACKGROUND_COLOR_HOVER: "#14142B",
        BORDER_COLOR: "#14142B",
        BORDER_COLOR_HOVER: "#14142B",
      },
      BADGE: {
        BACKGROUND: "#4B9EF9",
        TITLE: "#FFF",
      },
      SUBMENU: {
        CARD_BACKGROUND: "#FFF",
        BACKGROUND: "#FFF",
        BACKGROUND_HOVER: "rgba(0, 0, 0, 0.09)",
        TITLE: "#000",
        TITLE_HOVER: "#000",
        PARAGRAPH: "#3A3A3A",
        PARAGRAPH_HOVER: "#3A3A3A",
        LABEL: "#ED7426",
        LABEL_HOVER: "#ED7426",
        LINE: "#D9DBE9",
        LINE_HOVER: "#D9DBE9",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        LINK: "#00ADEE",
        LINK_HOVER: "#00ADEE",
      },
      TOPMENU: {
        BACKGROUND: "#FFFFFF",
        BACKGROUND_HOVER: "#F5F5FF",
        TITLE: "#14142B",
        TITLE_HOVER: "#14142B",
        PARAGRAPH: "#4E4B66",
        PARAGRAPH_HOVER: "#4E4B66",
        LINE: "#D9DBE9",
        LINE_HOVER: "#D9DBE9",
        BUTTON: {
          COLOR: "#fff",
          COLOR_HOVER: "#fff",
          BACKGROUND_COLOR: "transparent",
          BACKGROUND_COLOR_HOVER: "transparent",
          BORDER_COLOR: "#FFFFFF",
          BORDER_COLOR_HOVER: "#e3e52c",
        },
      },
    },
  },
  FOOTER: {
    VARIANT1: {
      BACKGROUND: "#231C39",
      BACKGROUND_SECOND: "#262338",
      TITLE: "#FFFFFF",
      TITLE_HOVER: "#FFFFFF",
      PARAGRAPH: "#FFFFFF",
      PARAGRAPH_HOVER: "#FFFFFF",
      LABEL: "#6E7191",
      LABEL_HOVER: "#6E7191",
      LINE: "#3E306A",
      LINE_HOVER: "#D9DBE9",
      BORDER_COLOR: "#D9DBE9",
      BORDER_COLOR_HOVER: "#14142B",
    },
  },
  ANIMATION: {
    IMAGE: {
      FADEINTIME: "1",
    },
  },
  COLOR: {
    BLACKCOLOR: "#14142B",
    WHITECOLOR: "#FFFFFF",
    BODYCOLOR: "#4E4B66",
    DEFAULT_TEXT_COLOR: "#3C3C3C",
    HIGHLIGHT_COLOR: "#ED7426",
    AVTAR_BG: "#e3e5eb",
    AVTAR_ICON_COLOR: "#1a1a1a",
  },
  FONTNAMEPRIMARY: "Brown",
  FONTNAMESECONDARY: "Brown",
};

export default ThemeConstants;
